/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { createContactDtoSchema } from "./createContactDtoSchema";
import { z } from "zod/v4";

export const createContactsBatchDtoSchema = z.object({
    get "contacts"(){
                return z.array(createContactDtoSchema).max(100)
              },
"dryRun": z.optional(z.boolean().default(false).describe("When true, computes and returns what each contact would look like without persisting anything")),
"monitor": z.optional(z.boolean().default(false).describe("When true, every successfully created contact starts out monitored (queuing its handle search and Radar sync). Ignored when dryRun is true."))
    })